import FormulaTableService from "@/service/FormulaTableService";

const newFormula = {
    index: null,
    formula: null,
    formulaTarget: null,
    color: null,
    sensorHigh: null,
    sensorLow: null,
    soilType: null,
    startDate: null,
    endDate: null,
    country: []
};

const formulaFilter = {
    formulaTarget: null,
    soilType: [],
    country: [],
    startDate: null,
    endDate: null
};

const initialState = {
    newFormula: { ...newFormula },
    formulaFilter: { ...formulaFilter },
    colors: [
        { title: "Red", color: "red" },
        { title: "Green", color: "green" },
        { title: "Orange", color: "orange" },
        { title: "Orange 2", color: "orange_2" }
    ], // if here is null then data gets pulled from BE
    formulaTargets: [],
    formulas: []
};

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchAllFormulas({ commit }, formulaType) {
            try {
                commit("setFormulas", []);
                const resp = await FormulaTableService.getAllFormulas(formulaType);
                if (!resp) commit("setFormulas", []);
                commit("setFormulas", resp.data);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchFormulaColors({ commit }) {
            try {
                const resp = await FormulaTableService.getColors();
                if (!resp) commit("setColors", []);
                commit("setColors", resp.data);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchFormulaTargets({ commit }, formulaType) {
            try {
                commit("setFormulaTargets", []);
                const resp = await FormulaTableService.getFormulaTargets(formulaType);
                if (!resp) commit("setFormulaTargets", []);
                commit("setFormulaTargets", resp.data);
            } catch (e) {
                console.error(e);
            }
        },
        async addNewFormula({ dispatch, commit, state }) {
            try {
                const resp = await FormulaTableService.addNewFormula(state.newFormula);
                if (resp && resp.data?.success) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "success"
                        },
                        { root: true }
                    );
                    const createdFormula = { ...state.newFormula };
                    createdFormula.id = resp.data?.formula_id;
                    commit("setFormulas", [...state.formulas, createdFormula]);
                    commit("setNewFormula");
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async duplicateFormula({ dispatch, commit, state }, payload) {
            try {
                const resp = await FormulaTableService.addNewFormula(payload.formula);
                if (resp && resp.data?.success) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "success"
                        },
                        { root: true }
                    );
                    const createdFormula = { ...payload.formula };
                    createdFormula.id = resp.data?.formula_id;
                    commit("setFormulas", [...state.formulas, createdFormula]);
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async editFormula({ dispatch }, payload) {
            try {
                const resp = await FormulaTableService.editFormula(payload.formula);
                if (resp && resp.data?.success) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "success"
                        },
                        { root: true }
                    );
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: resp.data?.message,
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async deleteFormula({ dispatch, commit, state }, payload) {
            try {
                const resp = await FormulaTableService.deleteFormula(payload.formulaId);
                if (resp) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Formula deleted",
                            type: "success"
                        },
                        { root: true }
                    );
                    const formulas = state.formulas.filter(item => item.id !== payload.formulaId);
                    commit("setFormulas", [...formulas]);
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Server error",
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        clearFormulaFilterDate({ state }, dateType) {
            if (dateType === "start") {
                state.formulaFilter.startDate = null;
            }
            if (dateType === "end") {
                state.formulaFilter.endDate = null;
            }
        }
    },
    mutations: {
        setColors(state, payload) {
            state.colors = payload;
        },
        setFormulaTargets(state, payload) {
            state.formulaTargets = payload;
        },
        setNewFormula(state) {
            state.newFormula = { ...newFormula };
        },
        setFormulas(state, payload) {
            state.formulas = payload;
        },
        setNewFormulaIndex(state, payload) {
            state.newFormula.index = payload.index;
        }
    },
    getters: {
        getFormulasOrderedByIndex(state) {
            return state.formulas.sort((a, b) => {
                try {
                    const letterA = a.index.replace(/[0-9]*/g, "");
                    const numberA = parseInt(a.index.replace(/[a-zA-z]*/g, ""));
                    const letterB = b.index.replace(/[0-9]*/g, "");
                    const numberB = parseInt(b.index.replace(/[a-zA-z]*/g, ""));
                    return letterB > letterA || numberB - numberA;
                } catch {
                    return 0;
                }
            });
        },
        getNextFormulaIndex(state, getters) {
            const orderedFormulas = getters.getFormulasOrderedByIndex;
            const highestFormulaIndex = orderedFormulas[0]?.index;
            if (!highestFormulaIndex) return "";
            let lowestMissingNumber = parseInt(highestFormulaIndex.replace(/[a-zA-z]*/g, "")) + 1;
            // find the first missing index
            for (let i = 1; i <= orderedFormulas.length; i++) {
                const currentFormulaIndex = orderedFormulas[orderedFormulas.length - i]?.index;
                const number = parseInt(currentFormulaIndex.replace(/[a-zA-z]*/g, ""));
                if (number !== i) {
                    lowestMissingNumber = i;
                    break;
                }
            }
            try {
                const letter = highestFormulaIndex.replace(/[0-9]*/g, "");
                return `${letter}${lowestMissingNumber}`;
            } catch {
                return "";
            }
        },
        getFilteredFormulas(state) {
            const { formulaFilter } = state;
            const filterBy = (filter, formulaValue) => {
                return filter.length === 0 || filter.every(value => formulaValue.includes(value));
            };
            return state.formulas.filter(formula => {
                return (
                    (!formulaFilter.formulaTarget || formula.formulaTarget.includes(formulaFilter.formulaTarget)) &&
                    filterBy(formulaFilter.soilType, formula.soilType) &&
                    filterBy(formulaFilter.country, formula.country) &&
                    (!formulaFilter.startDate || new Date(formula.startDate) >= new Date(formulaFilter.startDate)) &&
                    (!formulaFilter.endDate || new Date(formula.endDate) <= new Date(formulaFilter.endDate))
                );
            });
        }
    }
};
